import { IconButton, Icon } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useState, useEffect, useMemo } from "react";
import { useNavigate, Routes, Route, useParams } from "react-router-dom";
import { PaperTableHeader } from "../../../_components/table/header.table";
import { SearchTableHeader } from "../../../_components/table/search.table";
import { StandardTable } from "../../../_components/table/standard.table";
import { TABLE_FILTER } from "../../../_const/tableFilter.const";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { pettyCashService } from "../../../_services/pettyCash.service";
import { PettyCashManageDrawer } from "./pettyCash-manageDrawer";
import { StandardPanel } from "../../../_components/panel/standard.panel";
import { DataTypeEnum } from "../../../_common/enum/dataType.enum";
import { get7DaysRange, getDateString, } from "../../../_helpers/dateTime.helper";


export function PettyCashIndex() {
    const { centreId } = useParams<{ centreId: string }>();
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState({ ...TABLE_FILTER, ...get7DaysRange(), centreId: centreId });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true);
        return await pettyCashService.getAll(filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [filter]);

    function download() {
        return pettyCashService.exportReport(centreId, filter.dateFrom, filter.dateTo);
    }


    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 80,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate("PettyCash/Manage/" + row.original.id) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            {
                size: 3,
                accessorKey: 'date',
                header: 'Date',
                Cell: ({ row }) => (
                    <> {row.original.date ? getDateString(row.original.date) : ""} </>
                )
            },
            {
                size: 100,
                accessorKey: 'userName',
                header: 'User',
            },
            {
                size: 100,
                accessorKey: 'description',
                header: 'Description',
            },

            {
                size: 100,
                accessorKey: 'amount',
                header: 'Amount',
                Cell: ({ row }) => (
                    <> {row.original.amount ? "€ " + row.original.amount : "-"} </>
                )
            },
            {
                size: 100,
                accessorKey: 'status',
                header: 'Status',
                Cell: ({ row }) => (
                    <> {row.original.status ? "Active" : "Inactive"} </>
                )
            },

        ],
        []
    );

    return (
        <>
            <StandardPanel
                title="Petty Cash"
                buttons={[
                    { icon: "download", onClick: () => { download(); }, disabled: !data.count },
                    { icon: "add", onClick: () => { navigate("PettyCash/Create/") } },
                ]} loading={isLoading}>

                <SearchTableHeader inputs={[
                    { label: "Date From", name: "dateFrom", type: "date", onChange: setFilter, value: filter.dateFrom },
                    { label: "Date To", name: "dateTo", type: "date", onChange: setFilter, value: filter.dateTo },
                ]} />
                <StandardTable columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={setFilter}
                    loading={isLoading}></StandardTable>
            </StandardPanel>

            <Routes>
                <Route path="PettyCash/Create" element={<PettyCashManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
                <Route path="PettyCash/Manage/:id" element={<PettyCashManageDrawer onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
            </Routes>

        </>
    );
}


